var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoshopLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_6615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.167 40.418H130.834V129.585H39.167V40.418Z",
    fill: "url(#paint0_radial_309_6615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1666 40.4166H130.834V129.584H39.1666V40.4166ZM35 133.75H135V36.25H35V133.75ZM102.417 76.2501C99.1251 76.2501 98.0002 77.9167 98.0002 79.2917C98.0002 80.7916 98.7501 81.8333 103.167 84.125C109.708 87.2918 111.75 90.3334 111.75 94.7918C111.75 101.458 106.667 105.042 99.7918 105.042C96.1668 105.042 93.0417 104.292 91.2501 103.25C90.9585 103.125 90.9168 102.917 90.9168 102.583V96.4584C90.9168 96.0418 91.1251 95.9166 91.4169 96.1251C94.0419 97.8336 97.0418 98.5835 99.7918 98.5835C103.084 98.5835 104.459 97.2085 104.459 95.3334C104.459 93.8334 103.5 92.5001 99.2917 90.3334C93.375 87.5001 90.9168 84.6251 90.9168 79.8334C90.9168 74.4583 95.1252 70.0001 102.417 70.0001C106 70.0001 108.5 70.5418 109.875 71.1667C110.208 71.375 110.292 71.7083 110.292 72V77.7082C110.292 78.0415 110.083 78.25 109.667 78.1248C107.833 76.9585 105.125 76.2501 102.417 76.2501ZM66.5833 81.2084C67.5417 81.2917 68.2918 81.2917 69.9584 81.2917C74.8336 81.2917 79.4168 79.5835 79.4168 72.9585C79.4168 67.6669 76.1251 65 70.5835 65C68.9169 65 67.3334 65.0834 66.5833 65.125V81.2084ZM59.1668 59.0833C59.1668 58.7917 59.7502 58.5832 60.0834 58.5832C62.7502 58.4582 66.7085 58.3749 70.8334 58.3749C82.3751 58.3749 86.875 64.7083 86.875 72.7917C86.875 83.375 79.2083 87.9167 69.7918 87.9167C68.2085 87.9167 67.6669 87.8334 66.5417 87.8334V103.833C66.5417 104.167 66.4167 104.333 66.0417 104.333H59.6668C59.3335 104.333 59.1666 104.208 59.1666 103.833V59.0833H59.1668Z",
    fill: "#31C5F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_309_6615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.3576 60.4004) scale(69.6668 67.4501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34364E",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0824"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_6615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(35 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshopLogo);
export default __webpack_public_path__ + "static/media/photoshopLogo.eadfe49139f7e8da293042742e796884.svg";
export { ForwardRef as ReactComponent };